module.exports = __webpack_public_path__ + "static/img/rizqia-ac-panasonic-certificate.e2e857b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/certificate/rizqia-ac-panasonic-certificate.jpg
// module id = Dicg
// module chunks = 0